import script from "./index.vue?vue&type=script&setup=true&lang=ts"
export * from "./index.vue?vue&type=script&setup=true&lang=ts"

import "~/pages/_workflow.css?vue&type=style&index=0&id=63b66dde&scoped=true&lang=css&external"
import "./index.vue?vue&type=style&index=1&id=63b66dde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63b66dde"]])

export default __exports__